import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, StepControlType } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

export class InstructionTestFailedController extends AbstractStepController {

    private nextControl = new StepControl();

    onContextChange(contextChange: ContextChange) {

    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('text view started');

        this.dashboardContext.setContextValue('dashboardConfiguration', this.wizardComponent.currentStep.dashboardConfiguration);

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    getControls(): StepControl[] {
        const nextProcessStep = this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep;


        const controls = new Array<StepControl>();

        const spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
        this.nextControl.type = StepControlType.BUTTON;
        this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
        this.nextControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            if (nextProcessStep != null) {
              this.wizardComponent.next(nextProcessStep);
            } else {
              this.wizardComponent.next();
            }
        };
        controls.push(this.nextControl);

        return controls;
    }
}
